/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const LocationOutline = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 17 24" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M8.403 24.016l-.702-.712C2.523 18.055-.103 13.134-.103 8.68c0-4.766 3.816-8.644 8.506-8.644s8.506 3.878 8.506 8.644c0 4.454-2.626 9.375-7.803 14.624zm0-21.958c-3.593 0-6.517 2.97-6.517 6.622 0 3.702 2.192 7.893 6.517 12.466 4.325-4.573 6.517-8.764 6.517-12.466 0-3.652-2.924-6.622-6.517-6.622zm.057 10.79c-2.467 0-4.474-2.04-4.474-4.547 0-2.507 2.007-4.547 4.474-4.547 2.468 0 4.475 2.04 4.475 4.547 0 2.507-2.007 4.547-4.475 4.547zm0-7.073c-1.37 0-2.486 1.133-2.486 2.526 0 1.392 1.116 2.526 2.486 2.526s2.486-1.134 2.486-2.526c0-1.393-1.115-2.526-2.486-2.526z" />
      </g>
    </svg>
  </span>
);

LocationOutline.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

LocationOutline.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default LocationOutline;
